import actions from "./actions";
import mutations from "./mutations";

const state = {
  list_fasilitas: [],
  res_fasilitas_by_id: [],
  id_user: null,
  tempFasilitas: [],
  listMasterFasilitas: [],
  resMasterFasilitasById: [],
  tempMasterFasilitas: [],
  idMasterFacility: null,
  idFasilitas: null,
  list_approval: []
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
